import React from 'react';

import useClassy from '@core/hooks/useClassy';
import { useSuperHubStore } from '@core/store';

import Flex from '@ui/Flex';
import Icon from '@ui/Icon';
import Tooltip from '@ui/Tooltip';

import classes from './style.module.scss';

const PreviewSizeControl = () => {
  const bem = useClassy(classes, 'PreviewSizeControl');
  const [settingsPreviewMode, updateSettingsPreviewMode] = useSuperHubStore(s => [
    s.settingsPreviewMode,
    s.updateSettingsPreviewMode,
  ]);

  return (
    <Flex align="center" className={bem('')} gap="xs" justify="start">
      <Tooltip asTitle content={'Toggle preview between 100% and max container size'}>
        <button
          className={bem('-button', settingsPreviewMode === 'expand' && '-button_active')}
          onClick={() => updateSettingsPreviewMode(settingsPreviewMode === 'fit' ? 'expand' : 'fit')}
          type="button"
        >
          <Icon aria-hidden="false" className={bem('-button-icon')} name="fullscreen" />
          {settingsPreviewMode === 'expand' ? 'Responsive Preview' : 'Expand Preview'}
        </button>
      </Tooltip>
    </Flex>
  );
};

export default PreviewSizeControl;
